import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/react-hooks';
import moment from 'moment';
import mutateSetGrade from './mutateSetGrade.gql';
import query from './queryGrades.gql';
import messages from './messages';
import {
  MaxNumberInput,
  Button,
  SubmittedText,
  Notification,
} from '../ManualGradingReviewComponents/Form';

const ManualGradingFormContainer = ({
  studentId, deploymentId, componentId, attemptId, maxScore, createdAt, score: stateScore, interactiveId, cohortId }) => {
  const [score, setScore] = useState(stateScore);
  const [notifyState, setNotifyState] = useState(false);

  /* its possible that the component is now pointing to a new component,
   * in which case, we need to ensure that the state is refreshed from props
   * to prevent a stale input box
   */
  useEffect(() => {
    setScore(stateScore);
  }, [setScore, stateScore]);

  const [setGrade, { error }] = useMutation(mutateSetGrade, {
    onCompleted: () => {
      setNotifyState(true);
      setTimeout(() => { setNotifyState(false); }, 1000);
    },
    update: (proxy, { data }) => {
      const variables = { cohortId, deploymentId, componentId, interactiveId, studentId };
      const queryData = _.cloneDeep(proxy.readQuery({ query, variables }));
      queryData.cohortById.enrollmentByStudent.getLatestAttemptStudentManualGradeReport.grades.push({ ...data.ManualGradeCreate });
      proxy.writeQuery({ query, variables, data: queryData });
    },
  });

  if (error) throw new Error(error);

  const onClick = React.useCallback(() => {
    setGrade({ variables: {
      studentId,
      deploymentId,
      componentId,
      attemptId,
      score,
    } });
  }, [setGrade, studentId, deploymentId, componentId, attemptId, score]);

  return (
    <div>
      <SubmittedText>
        {createdAt ?
          <FormattedMessage {...messages.submittedDate} values={{ createdAt: moment(createdAt).format('MMMM Do YYYY, h:mm a') }} />
          : <FormattedMessage {...messages.ungraded} />}
      </SubmittedText>
      <MaxNumberInput
        value={`${score}`}
        onChange={(evt) => setScore(evt.target.value)}
        max={maxScore}
        label="Grade"
      />
      <Button
        primary
        disabled={score === null || score === ''}
        onClick={onClick}
      >
        <FormattedMessage {...messages.submitBtn} />
        { notifyState &&
          <Notification>
            <FormattedMessage {...messages.gradeAssigned} />
          </Notification>
        }
      </Button>
    </div>
  );
};

ManualGradingFormContainer.propTypes = {
  cohortId: PropTypes.string.isRequired,
  interactiveId: PropTypes.string.isRequired,
  studentId: PropTypes.string.isRequired,
  deploymentId: PropTypes.string.isRequired,
  componentId: PropTypes.string.isRequired,
  attemptId: PropTypes.string.isRequired,
  maxScore: PropTypes.number.isRequired,
  createdAt: PropTypes.any,
  score: PropTypes.number,
};

export default ManualGradingFormContainer;
